<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/invoices">Invoices</a>
            </span>
          </div>

          <div class="row negative-margin">
            <div class="col-md-12">
              <div *ngIf="sessionExpired" class="alert alert-danger session-text text-center" role="alert">
                {{ errorMsg }}
                <span class="relogin" (click)="accountLogout()">Click here to LogIn</span>
              </div>
              <div *ngIf="vendorError && invoiceError" class="alert alert-danger session-text text-center" role="alert">
                {{ errorMsg }}
                <span class="relogin" (click)="accountLogout()">Click here to LogIn</span>
              </div>
              <div class="card manage-invoice">
                <div class="card-body">
                  <div class="pane-header mb-3">
                    <div class="row">
                      <div class="col-md-6">
                        <h4 class="mt-2">Manage Invoices</h4>
                      </div>
                      <div class="col-md-6">
                        <div class="actions-pane float-end mt-2" *ngIf="canSubmitNonPo || canSubmitLogistics">
                          <span class="dropdown">
                            <button class="btn btn-invoice dropdown-toggle mr-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">Submit Invoice</button>
                            <ul class="dropdown-menu">
                              <li>
                                <a class="dropdown-item" routerLink="/purchase-orders"> With PO </a>
                              </li>
                              <li *ngIf="canSubmitNonPo">
                                <a class="dropdown-item" routerLink="/submit-nonpo-invoice"> Without PO </a>
                              </li>
                              <li *ngIf="canSubmitLogistics">
                                <a class="dropdown-item" routerLink="/submit-logistics-invoice"> Logistics </a>
                              </li>
                            </ul>
                          </span>
                        </div>

                        <div class="actions-pane float-end mt-2" *ngIf="!canSubmitNonPo && !canSubmitLogistics">
                          <span class="dropdown">
                            <a class="dropdown-item" routerLink="/purchase-orders">
                              <button class="btn btn-invoice dropdown-toggle mr-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">Submit PO Invoice</button>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="search-pane">
                    <div class="row">
                      <div class="col-md-2 col-sm-4">
                        <label class="d-inline-flex align-items-center mb-3">
                          <select id="show-headers" class="form-select form-select-sm mx-1" [(ngModel)]="filterBy" (change)="onFilter($event)">
                            <option disabled selected hidden>Select</option>
                            <option value="docIdRegex">Invoice No.</option>
                            <option value="barcodeRegex">Barcode No.</option>
                            <option value="poNoNumberOrString">PO No.</option>
                            <option value="statusRegex">Current Status</option>
                          </select>
                        </label>
                      </div>
                      <div class="col-md-4 col-sm-8">
                        <div class="input-group flex-nowrap">
                          <input
                            type="text"
                            class="form-control highlighted"
                            placeholder="Enter search value"
                            aria-label="search"
                            aria-describedby="addon-wrapping"
                            (keyup)="onSearch($event)"
                          />
                          <span class="input-group-text highlighted" id="addon-wrapping"><i class="ri-search-line"></i></span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="download-pane float-end d-flex align-items-center gap-3">
                          <i
                            class="ri-refresh-line"
                            title="Refresh"
                            (click)="!loading && !fetching && fetchInvoices()"
                            [style.opacity]="loading || fetching ? 0.45 : 1"
                            [style.pointer-events]="loading || fetching ? 'none' : 'auto'"
                          ></i>
                          <i class="ri-file-download-line" (click)="exportToExcel()"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <div class="loader text-center" *ngIf="loading || fetching">
                      <app-loader></app-loader>
                    </div>
                    <ng-container *ngIf="!loading && !fetching">
                      <div *ngIf="isEmpty" class="text-center py-5">
                        <img src="assets/images/empty-state.png" alt="No-data" />
                        <h1 class="card-title my-2">No Invoices Available</h1>
                        <p class="card-text">There is no available data to show yet</p>
                      </div>
                      <ng-container *ngIf="!isEmpty">
                        <table aria-describedby="invoices-list" class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap" data-page-size="5">
                          <thead>
                            <tr>
                              <th></th>
                              <th scope="col" [appSort]="invs" data-order="desc" data-name="invoice_number">
                                Invoice Number
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <!-- <th
                                                                scope="col"
                                                                [appSort]="invs"
                                                                data-order="desc"
                                                                data-name="doc_type"
                                                            >
                                                                Doc Type
                                                                <span
                                                                    ><i
                                                                        class="bi bi-chevron-expand"
                                                                    ></i
                                                                ></span>
                                                            </th> -->

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="barcode">
                                Barcode No
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="poNo">
                                PO No.
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="invoice_amount">
                                Invoice Amount
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="po_currency">
                                Currency
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="status">
                                Current Status
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="po_currency">
                                Payment Due Date
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>

                              <th scope="col" [appSort]="invs" data-order="desc" data-name="po_currency">
                                GST Reconciled?
                                <span><i class="bi bi-chevron-expand"></i></span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let invoice of invs">
                              <tr>
                                <td>
                                  <input
                                    *ngIf="invoice.status !== 'Rejected' && invoice.docDetail?.docCat !== 'non_po_based'"
                                    class="form-check-input"
                                    type="checkbox"
                                    [(ngModel)]="invoice.selected"
                                    (change)="onSelectChanges(invoice)"
                                  />
                                </td>
                                <td>
                                  <a routerLink="/invoice-detail/{{ invoice.barcode }}">{{ invoice.invoice_number }}</a>
                                </td>
                                <td>
                                  {{ invoice.barcode }}
                                </td>
                                <td>
                                  {{ invoice.poNo }}
                                </td>
                                <td>
                                  {{ invoice.invoice_amount | inrdisplay }}
                                </td>
                                <td>
                                  {{ invoice.po_currency }}
                                </td>
                                <td>
                                  <ng-container
                                    *ngIf="
                                      invoice.status === 'SUBMITTED' ||
                                      invoice.status === 'Pending_submission' ||
                                      invoice.status === 'Pending_Submission' ||
                                      invoice.status === 'PENDING_SUBMISSION' ||
                                      invoice.status === 'Pending Shipping Approval' ||
                                      invoice.status === 'Pending Veson Approval'
                                    "
                                  >
                                    <span class="badge text-bg-primary submitted query">{{ invoice.status.replaceAll("_", " ") | titlecase }}</span>
                                    <span *ngIf="invoice.status === 'Pending_submission' || invoice.status === 'PENDING_SUBMISSION'">
                                      <ng-container *ngIf="invoice.reference_details.docType === 'PO2S - PO2S'">
                                        <i
                                          class="ri-information-fill"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="This invoice is pending level 1 approval by the shipping team before processing."
                                        ></i>
                                      </ng-container>

                                      <ng-container *ngIf="invoice.reference_details.docType !== 'PO2S - PO2S'">
                                        <i
                                          class="ri-information-fill"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Sorry, there may be an issue. We will retry automatically later. If it has been more than 24hrs, contact support."
                                        ></i>
                                      </ng-container>
                                    </span>
                                  </ng-container>

                                  <span *ngIf="invoice.status === 'In Processing' || invoice.status === 'IN_PROCESSING'" class="badge text-bg-primary processing">
                                    In Processing
                                  </span>
                                  <span *ngIf="invoice.status === 'In Query' || invoice.status === 'IN_QUERY'" class="badge text-bg-primary processing">
                                    In Query
                                  </span>
                                  <span *ngIf="invoice.status === 'posted' || invoice.status === 'Posted' || invoice.status === 'POSTED'" class="badge text-bg-primary posted">{{
                                    invoice.status | titlecase
                                  }}</span>
                                  <span *ngIf="invoice.status === 'Cleared' || invoice.status === 'CLEARED'" class="badge text-bg-primary cleared">{{ invoice.status | titlecase }}</span>
                                  <span
                                    *ngIf="invoice.status === 'Accepted' || invoice.status === 'Approved' || invoice.status === 'ACCEPTED' || invoice.status === 'APPROVED'"
                                    class="badge text-bg-primary accepted approved"
                                    >{{ invoice.status | titlecase }}</span
                                  >
                                  <span *ngIf="invoice.status === 'Paid' || invoice.status === 'PAID'" class="badge text-bg-primary paid">{{ invoice.status | titlecase }}</span>
                                  <ng-container *ngIf="invoice.reference_details.docType !== 'PO2S - PO2S' && invoice.status !== 'Rejected' && invoice.status !== 'REJECTED'">
                                    <i *ngIf="invoice.status_reason !== ''" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ invoice.status_reason }}"></i>
                                  </ng-container>
                                  <ng-container *ngIf="invoice.status === 'Rejected' || invoice.status === 'rejected' || invoice.status === 'REJECTED'">
                                    <span class="badge text-bg-primary rejected">{{ invoice.status | titlecase }}</span>
                                    <span *ngIf="invoice.status === 'Rejected' || invoice.status === 'rejected' || invoice.status === 'REJECTED'">
                                      <ng-container *ngIf="invoice.reference_details.docType === 'PO2S - PO2S' || invoice.reference_details.docType === 'PO2S'">
                                        <i *ngIf="invoice.rejection1" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ invoice.rejections.rej1.reason }}"></i>
                                        <i *ngIf="invoice.rejection2" class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ invoice.rejections.rej2.reason }}"></i>

                                        <ng-container *ngIf="invoice.status_reason !== ''">
                                          <i class="ri-information-fill" data-toggle="tooltip" data-placement="bottom" title="{{ invoice.status_reason }}"></i>
                                        </ng-container>
                                      </ng-container>
                                    </span>
                                  </ng-container>
                                </td>
                                <td>
                                  {{ invoice.payment_due_date_iso }}
                                </td>
                                <td>
                                  <ng-container *ngIf="invoice.gst_exist">
                                    <p *ngIf="invoice.gst_reconciled === 'TRUE'">Yes</p>
                                    <p *ngIf="invoice.gst_reconciled === 'FALSE'">Not Available</p>
                                    <p *ngIf="invoice.gst_reconciled === 'UNKNOWN'">Not Available</p>
                                  </ng-container>

                                  <ng-container *ngIf="!invoice.gst_exist"> Not Available </ng-container>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="9">
                                <button *ngIf="impersonate === 'false'" [disabled]="!isSelected" class="btn btn-invoice float-start" (click)="sendInvoice()">
                                  Submit Credit/Debit Note for Selected Invoice(s)
                                </button>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </ng-container>
                    </ng-container>
                    <div class="table-footer py-3">
                      <div class="row">
                        <div class="col-sm-5">
                          <label class="d-inline-flex align-items-center mb-3">
                            Show
                            <select id="demo-show-entries" class="form-select form-select-sm mx-1" [(ngModel)]="pageSize" (ngModelChange)="page = 1; fetchInvoices()">
                              <option [ngValue]="10">10</option>
                              <option [ngValue]="25">25</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            entries
                          </label>
                        </div>
                        <div class="col-sm-7">
                          <div class="text-end">
                            <!-- Showing 1-5 of 15 entries -->
                            <ngb-pagination
                              class="justify-content: flex-end !important;"
                              [collectionSize]="collectionSize"
                              [(page)]="page"
                              [pageSize]="pageSize"
                              [maxSize]="4"
                              [rotate]="true"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                              (pageChange)="fetchInvoices()"
                            >
                            </ngb-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
